import React from 'react';
import { FaEnvelope, FaPhoneAlt, FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { Container, Row, Col } from 'react-bootstrap';
import './TopBar.css';
import logo from '../assets/Images/LogoPic.png';

function TopBar() {
  return (
    <div className="topbar-bg">
      <Container fluid>
        <Row className="align-items-center justify-content-between">
          
          {/* LEFT BLUE BLOCK */}
          <Col lg={5} md={6} xs={12} className="left-block">
            <div className="left-content">
              <a href="mailto:example@mail.com" className="left-item">
                <FaEnvelope className="left-icon" color='#000000'/> example@mail.com
              </a>
              <a href="tel:+923001234567" className="left-item" >
                <FaPhoneAlt className="left-icon" color='green'/> +92 300 1234567
              </a>
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaFacebookF color='BLUE' />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaLinkedinIn  color=' #0A66C2'/>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link">
                <FaInstagram  color='#E1306C'/>
              </a>
            </div>
          </Col>

          {/* RIGHT SECTION (same as before) */}
          <Col lg={7} md={6} xs={12}>
            <div className="topbar-item links-block">
              <a href="#about">About Us</a><span className="separator"> | </span>
              <a href="#material">Our Material</a><span className="separator"> | </span>
              <a href="#company">Company Profile</a><span className="separator"> | </span>
              <a href="#catalog">Catalog</a><span className="separator"> | </span>
              <a href="#faqs">FAQs</a><span className="separator"> | </span>
              <span className="cart-text">0 item(s)</span>
            </div>
          </Col>

        </Row>
      </Container>
    </div>
  );
}

export default TopBar;